import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../contexts/AuthContext";
import RequireGroup from "./RequireGroup";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const EstoqueAtual = ({ title, excelButtonRoute, pdfButtonRoute}) => {
  const [movements, setMovements] = useState([]);
  const [groupedData, setGroupedData] = useState([]);
  const [search, setSearch] = useState("");
  const [entries, setEntries] = useState(50);
  const { user } = useContext(AuthContext);
  
  const [sortConfig, setSortConfig] = useState({
    key: "lastMovement",
    direction: "desc"
  });
  
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  useEffect(() => {
    const fetchMovements = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}estoque/`);
        if (!response.ok) {
          throw new Error(`Erro na requisição: ${response.status}`);
        }
        const result = await response.json();
        setMovements(result);
      } catch (error) {
        console.error("Erro ao buscar dados do estoque:", error);
      }
    };

    fetchMovements();
  }, []);

  useEffect(() => {
    const grouped = movements.reduce((acc, movimento) => {
      const key = movimento.item.descricao;
      if (!acc[key]) {
        acc[key] = {
          descricaoItem: movimento.item.descricao,
          tipo_item: movimento.item.tipo_item,
          totalEntrada: 0,
          totalSaida: 0,
          estoqueAtual: 0,
          lastMovement: null,
        };
      }
      if (movimento.tipo === "Entrada") {
        acc[key].totalEntrada += parseFloat(movimento.quantidade);
      } else if (movimento.tipo === "Saida") {
        acc[key].totalSaida += parseFloat(movimento.quantidade);
      }
      acc[key].estoqueAtual = acc[key].totalEntrada - acc[key].totalSaida;
      
      const dataStr = movimento.data_movimento;
      const horaStr = movimento.hora_movimento.split(".")[0];
      const movimentoDateTime = new Date(`${dataStr}T${horaStr}`);
      
      if (!acc[key].lastMovement || movimentoDateTime > acc[key].lastMovement) {
        acc[key].lastMovement = movimentoDateTime;
      }
      return acc;
    }, {});
    
    setGroupedData(Object.values(grouped));
  }, [movements]);

  const sortedData = useMemo(() => {
    const sorted = [...groupedData].sort((a, b) => {
      let aValue = a[sortConfig.key];
      let bValue = b[sortConfig.key];
      if (sortConfig.key === "lastMovement") {
        aValue = aValue ? new Date(aValue) : new Date(0);
        bValue = bValue ? new Date(bValue) : new Date(0);
      }
      if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
    return sorted;
  }, [groupedData, sortConfig]);

  const handleEntriesChange = (e) => setEntries(e.target.value);
  const filteredData = sortedData.filter((item) => {
    const searchString = (
      item.descricaoItem +
      " " +
      item.tipo_item +
      " " +
      item.totalEntrada +
      " " +
      item.totalSaida +
      " " +
      item.estoqueAtual +
      " " +
      (item.lastMovement ? item.lastMovement.toLocaleString() : "")
    ).toLowerCase();
    return searchString.includes(search.toLowerCase());
  });

  return (
    <div className="page-body">
      <div className="container-xl">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
             <h3 className="card-title">{title}</h3>
            
            
              <div className="btn-list">
                <a
                  href={pdfButtonRoute}
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                  className="btn btn-danger d-flex align-items-center"
                >
                  <span className="ms-1">PDF</span>
                </a>
                  <a
                    href={excelButtonRoute}
                    target="_blank"
                    rel="noopener noreferrer"
                    download
                    className="btn btn-success d-flex align-items-center"
                  >
                    <span className="ms-1">Excel</span>
                  </a>
              </div>
          </div>
          <div className="card-body border-bottom py-3">
            <div className="d-flex">
            <div className="text-secondary">
            Mostrar
            <div className="mx-2 d-inline-block">
              <input
                type="text"
                className="form-control form-control-sm"
                value={entries}
                onChange={handleEntriesChange}
                size="3"
                aria-label="Contador de registros"
              />
            </div>
            registros
          </div>
            <div className="ms-auto text-secondary">
              Procurar:
              <div className="ms-2 d-inline-block">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  aria-label="Procurar"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
          </div>
          </div>

          <div className="card-body p-0">
            <div id="table-default" className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>
                      <button className="table-sort" data-sort="sort-name" onClick={() => handleSort('descricaoItem')}>
                        Item
                      </button>
                    </th>
                    <th>
                      <button className="table-sort" data-sort="sort-entrada" onClick={() => handleSort('totalEntrada')}>
                        Quantidade Entrada
                      </button>
                    </th>
                    <th>
                      <button className="table-sort" data-sort="sort-saida" onClick={() => handleSort('totalSaida')}>
                        Quantidade Saída
                      </button>
                    </th>
                    <th>
                      <button className="table-sort" data-sort="sort-atual" onClick={() => handleSort('estoqueAtual')}>
                        Estoque Atual
                      </button>
                    </th>
                    <th>
                      <button className="table-sort" data-sort="sort-date" onClick={() => handleSort('lastMovement')}>
                        Último Movimento
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody className="table-tbody">
                  {filteredData.slice(0, Number(entries)).map((item, index) => (
                    <tr key={index}>
                      <td className="sort-name">{item.descricaoItem.toUpperCase()} - [{item.tipo_item.toUpperCase()}]</td>
                      <td className="sort-entrada">{item.totalEntrada}</td>
                      <td className="sort-saida">{item.totalSaida}</td>
                      <td className="sort-atual">{item.estoqueAtual}</td>
                      <td className="sort-date">
                        {item.lastMovement
                          ? item.lastMovement.toLocaleDateString("pt-BR", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            }) +
                            " " +
                            item.lastMovement.toLocaleTimeString("pt-BR", {
                              hour: "2-digit",
                              minute: "2-digit",
                            })
                          : ""}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EstoqueAtual;